// extracted by mini-css-extract-plugin
var _1 = "LwXdN6yLlIVHiIyEZ8Pa";
export { _1 as "frames" }
